module.exports = __webpack_public_path__ + "static/media/RoosterandtheDancingDiabloBookCover.c486d32b.jpg";